<style>
  .my-pagination /deep/ .ngx-pagination {
    text-align: center;

  }
</style>
<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/corporate/attribute-operator-association-list"> Attribute Operator Association List</a></li>
      <li class="breadcrumb-item active" aria-current="page">New Attribute Operator Association</li>
    </ol>
  </nav>
</div>

<div class="container">
  <form class="form-horizontal mt-1" [formGroup]="attributeForm">
    <div class="row">
      <div class="col-md-10 col-xl-7">

        <div class="card mt-1">

          <div class="card-body">


            <div class="form-group">
              <label for="attributeForm">Attribute Name <span style="color:red">*</span></label>
              <select formControlName="aid" class="form-control formstyle"
                      [ngClass]="{ 'is-invalid': submitted && f.aid.errors }"  (change)="getAttributeOperator($event.target.value)">

                <option value="">Please Select Attribute</option>
                <option *ngFor="let userObj of attributes" value={{userObj.field_id}}>
                  {{userObj.field_name}}
                </option>
              </select>
              <div *ngIf="submitted && f.aid.errors" class="invalid-feedback">
                <div *ngIf="f.aid.errors.required">Attribute is required</div>
              </div>
            </div>

            <div class="form-group" *ngIf="show">
              <label for="attributeForm">Operator Name</label>
              <div class="piInnerList scroller">
                <ul class="filtMain">
                  <li *ngFor="let item of operatorList">
                    <div class="row">
                      <div class="col-sm-9">
                        <label class="form-check-label">
                          {{item.operator_name}}
                        </label>
                      </div>

                      <div class="col-sm-3">
                        <input  [checked]="operatorid.indexOf(item.operator_id)==0 || operatorid.indexOf(item.operator_id)>0"  type="checkbox"  (change)="selectOperators($event, item.operator_id)">
                      </div>

                    </div>

                  </li>
                </ul>
              </div>

            </div>
          </div>
          <div class="card-footer text-center ">
            <div class="my_class text-center">
              <button type="submit" class="custbtn" *ngIf="isWrite" (click)="addOperators()">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
